import { inr } from "@/lib/calc";
import { leaderboard } from "@/lib/status";

export const Leaderboard = ({ rows }) => {
  const list = leaderboard(rows);
  const max = Math.max(1, ...list.map((l) => l.receipts));
  return (
    <div className="rounded-lg border border-plum-900/10 bg-white p-5" data-testid="dash-leaderboard">
      <h2 className="font-display mb-4 text-base font-bold text-plum-950">Counsellor Leaderboard</h2>
      {!list.length ? <p className="py-4 text-sm text-slate-500">No receipts in this period.</p> : (
        <div className="overflow-x-auto">
          <table className="w-full min-w-[640px] text-sm">
            <thead>
              <tr className="border-b border-slate-200 font-bold text-left text-[11px] uppercase tracking-wider text-slate-500">
                <th className="w-8 py-2">#</th><th className="py-2">Counsellor</th><th className="py-2">Receipts</th>
                <th className="py-2 text-right">Admitted</th><th className="py-2 text-right">Conversion</th>
                <th className="py-2 text-right">Due at Admission</th><th className="py-2 text-right">Discounts Given</th>
                <th className="py-2 text-right">Avg Discount</th>
              </tr>
            </thead>
            <tbody>
              {list.map((l, i) => {
                const slug = l.name.toLowerCase().replace(/\s+/g, "-");
                return (
                  <tr key={l.name} className="border-b border-slate-100" data-testid={`lb-row-${slug}`}>
                    <td className="font-num py-2.5 text-slate-400">{i + 1}</td>
                    <td className={`py-2.5 font-medium ${l.name === "Unassigned" ? "italic text-slate-500" : ""}`}>{l.name}</td>
                    <td className="py-2.5">
                      <div className="flex items-center gap-2">
                        <div className="h-2 w-24 rounded-full bg-slate-100"><div className="h-2 rounded-full bg-plum-900" style={{ width: `${(l.receipts / max) * 100}%` }} /></div>
                        <span className="font-num font-medium" data-testid={`lb-receipts-${slug}`}>{l.receipts}</span>
                      </div>
                    </td>
                    <td className="font-num py-2.5 text-right" data-testid={`lb-admitted-${slug}`}>{l.admitted}</td>
                    <td className="font-num py-2.5 text-right text-plum-700">{Math.round((l.admitted / l.receipts) * 100)}%</td>
                    <td className="font-num py-2.5 text-right">₹ {inr(l.atAdmission)}</td>
                    <td className="font-num py-2.5 text-right" data-testid={`lb-discount-${slug}`}>₹ {inr(l.discount)}</td>
                    <td className="font-num py-2.5 text-right text-slate-600">₹ {inr(Math.round(l.discount / l.receipts))}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
